import React from 'react'
import { MenuOverlay, Separator, Skeleton } from '@fs/zion-ui'
import CompareAction, { OtherActions } from './genealogy-table/CompareAction'

export default function GenealogyTreeMenu({ onDeleteClick, tree, menuOverlay }) {
  return (
    <MenuOverlay {...menuOverlay}>
      <CompareAction type="ListIem" tree={tree} />

      <OtherActions type="ListIem" tree={tree} onDeleteClick={onDeleteClick} />
    </MenuOverlay>
  )
}

/* eslint-disable test-selectors/button -- loading skeletons */
export function GenealogyTreeMenuSkeleton({ menuOverlay }) {
  return (
    <MenuOverlay {...menuOverlay}>
      <Separator size="nano" />
      <Skeleton.Button width={120} />
      <Separator size="nano" />
      <Skeleton.Button width={120} />
      <Separator size="nano" />
      <Skeleton.Button width={120} />
      <Separator size="nano" />
    </MenuOverlay>
  )
}
/* eslint-enable test-selectors/button -- re-enable after skeleton */
